// extracted by mini-css-extract-plugin
export default {"chart_card_wrapper":"ScoreReport_chart_card_wrapper__R9R9u","chart_title":"ScoreReport_chart_title__W5pAK"};